const parser = new DOMParser();

export const decodeHtml = (value: any) => {
    if (typeof value === "string" && value !== "") {
        const doc = parser.parseFromString(value, "text/html");
        return doc.documentElement.textContent;
    } else {
        return value;
    }
};

// used for bulk select. Will return an empty array or a subset of the results array where that subset is the array between startId and endId
export const generateSelectedIdArray = (startId: string, endId: string, array: string[]) => {
    const arrayLength = array.length;
    const lastIndex = arrayLength - 1;
    const startIdIndex = array.findIndex((elem) => startId === elem);
    const endIdIndex = array.findIndex((elem) => endId === elem);
    const indexesAreValid = startIdIndex > -1 && endIdIndex > -1;

    // null checking.
    if (!indexesAreValid || startId === "" || endId === "") {
        return [];
    }

    if (startIdIndex < endIdIndex) {
        if (endIdIndex >= lastIndex) {
            return array.slice(startIdIndex);
        }
        return array.slice(startIdIndex, endIdIndex + 1);
    }

    // endIdIndex < startIdindex
    if (startIdIndex >= lastIndex) {
        return array.slice(endIdIndex);
    }
    return array.slice(endIdIndex, startIdIndex + 1);
};

export enum Status {
    Failed = "not sent",
    Sent = "sent",
    Active = "active",
    Status = "status",
}
